import { Link } from 'react-router-dom';
import type { ArticleItem } from '@/mocks/articles';
import { formatViews } from '@/mocks/videos';

interface ArticleCardProps {
  article: ArticleItem;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300"
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          title={`蘑菇成品人视频 - ${article.title}`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/40 to-transparent"></div>
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          {article.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800"
            >
              {tag}
            </span>
          ))}
        </div>
        <h3 className="font-heading text-foreground-900 text-sm leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
          {article.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">
          {article.summary}
        </p>
        <div className="flex items-center justify-between mt-3 text-xs text-foreground-400">
          <span>{article.author}</span>
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatViews(article.views)}
            </span>
            <span>{article.date}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}